import SelectCredit from './SelectCredit'
export default SelectCredit
